import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/solid';
import '../../styles/main.scss';
import uploadlogo from '../images/upload_logo.svg';
import Logout from '../images/logo_logout.svg';
import ThemeToggle from '../common/ThemeToggle';
import { useAuth } from '../../AuthContext';
import { ROUTES } from '../../constants/routes';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname === ROUTES.DASHBOARD;
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (err) {
      console.error('Logout failed:', err);
      window.location.replace(ROUTES.LOGIN);
    }
  };

  return (
    <header className="header">
      <div className="header-logo">
        <img src={uploadlogo} alt="logo" />
      </div>
      <div className="header-actions">
        <button
          type="button"
          className={`header-dashboard-btn${isDashboard ? ' is-active' : ''}`}
          onClick={() => navigate(ROUTES.DASHBOARD)}
          aria-label="Go to Dashboard"
          aria-current={isDashboard ? 'page' : undefined}
        >
          <span className="header-dashboard-btn__icon-wrap" aria-hidden="true">
            <HomeIcon />
          </span>
          <span className="header-dashboard-btn__label">Dashboard</span>
        </button>
        <ThemeToggle />
        <button type="button" className="logout-btn" onClick={handleLogout}>
          <img src={Logout} alt="logout" />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
